import { groupBy } from 'data/array';
import { MessageTemplateScore } from './models/MessageTemplateScore';
export class MessageTemplateUtil {
    constructor() { }
    convertToMessageTemplate(items) {
        const groupedByName = groupBy(items, 'name');
        const messageTemplates = Object.keys(groupedByName).map(k => ({
            name: k,
            category: groupedByName[k][0].category,
            translations: groupedByName[k].map(t => {
                const headerComponent = t.components.find(c => c.type === 'HEADER');
                const bodyComponent = t.components.find(c => c.type === 'BODY');
                const buttonsComponent = t.components.find(c => c.type === 'BUTTONS');
                const footerComponent = t.components.find(c => c.type === 'FOOTER');
                const hasOrderDetailsButton = buttonsComponent?.buttons?.some(b => b.type === 'ORDER_DETAILS');
                const carouselComponent = t.components.find(b => b.type === 'CAROUSEL');
                const getTemplateType = () => {
                    const headerComponentFormat = headerComponent?.format?.toLowerCase();
                    if (hasOrderDetailsButton && headerComponentFormat) {
                        return headerComponentFormat;
                    }
                    if (carouselComponent) {
                        return 'carousel';
                    }
                    if (headerComponentFormat &&
                        headerComponentFormat !== 'TEXT') {
                        return headerComponentFormat;
                    }
                    if (bodyComponent || headerComponentFormat === 'TEXT') {
                        return 'text';
                    }
                    return undefined;
                };
                return {
                    type: getTemplateType(),
                    language: t.language,
                    text: bodyComponent
                        ? bodyComponent.text
                        : headerComponent
                            ? headerComponent.text
                            : undefined,
                    header: headerComponent ? headerComponent.text : undefined,
                    buttons: buttonsComponent?.buttons,
                    footer: footerComponent?.text,
                    status: t.status,
                    rejectedReason: t.rejected_reason,
                    imageLink: headerComponent
                        ? this.getFileLinkFromHeader(headerComponent)
                        : '',
                    documentLink: headerComponent
                        ? this.getFileLinkFromHeader(headerComponent)
                        : '',
                    videoLink: headerComponent
                        ? this.getFileLinkFromHeader(headerComponent)
                        : '',
                    category: t.category,
                    isRecategorized: t.previous_category !== undefined,
                    qualityScore: t.quality_score
                        ? t.quality_score
                        : { score: MessageTemplateScore.UNKNOWN },
                    bidSpec: t.bid_spec
                        ? { bidAmount: t.bid_spec.bid_amount }
                        : undefined,
                    cards: carouselComponent?.cards || [],
                };
            }),
        }));
        return messageTemplates;
    }
    getFileLinkFromHeader(component) {
        const type = component.type === 'BODY' ? 'text' : component.format.toLowerCase();
        if (this.existHeaderHandler(component)) {
            switch (type) {
                case 'text':
                    return '';
                case 'image':
                    return component.example.header_handle[0];
                case 'document':
                    return component.example.header_handle[0];
                case 'video':
                    return component.example.header_handle[0];
                default:
                    return '';
            }
        }
    }
    existHeaderHandler(component) {
        if (component != undefined &&
            component.example != undefined &&
            component.example.header_handle != undefined) {
            return true;
        }
        else {
            return false;
        }
    }
    formatMessageToPreviewView(message) {
        let value = message;
        const searchBoldText = value.match(/\*(\S(.*?\S)?)\*/gm);
        const searchItalicText = value.match(/\_(\S(.*?\S)?)\_/gm);
        const searchStrikethroughText = value.match(/\~(\S(.*?\S)?)\~/gm);
        const searchNewLines = value.match(/\\n/gm);
        const searchLineBreaks = value.match(/\n/gm);
        const replaceSymbolForTag = (value, tag) => {
            return `<${tag}>${value.substring(1, value.length - 1)}</${tag}>`;
        };
        searchBoldText &&
            searchBoldText.map(text => {
                value = value.replace(text, replaceSymbolForTag(text, 'b'));
            });
        searchItalicText &&
            searchItalicText.map(text => {
                value = value.replace(text, replaceSymbolForTag(text, 'i'));
            });
        searchStrikethroughText &&
            searchStrikethroughText.map(text => {
                value = value.replace(text, replaceSymbolForTag(text, 'strike'));
            });
        searchNewLines &&
            searchNewLines.map(lineBreak => {
                value = value.replace(lineBreak, '<br>');
            });
        searchLineBreaks &&
            searchLineBreaks.map(lineBreak => {
                value = value.replace(lineBreak, '<br>');
            });
        return value;
    }
}
